import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { cx } from '@/utils/cx';

export type ButtonLinkProps = LinkProps & {
  variant?: 'primary' | 'secondary' | 'unstyled';
};

export const ButtonLink: FC<ButtonLinkProps> = ({
  children,
  variant = 'primary',
  ...props
}) => (
  <Link
    {...props}
    className={cx(
      'button',
      variant !== 'unstyled' && `button button-${variant}`,
      props.className,
    )}
  >
    {children}
  </Link>
);
